/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";  
import {  
  PostService,
} from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService"; 
import MoonLoader from "react-spinners/MoonLoader";
import Pagination from "../../../../Helper/Pagination";
import {
  showSuccessAlert,
  showErrorAlert,
  showDeleteConfirmation,
} from "../../../../Helper/SweetAlert"; 

export default function StateList() {
    const [TotalPageCount, SetTotalPageCount] = useState();
    const [TotalCount, SetTotalCount] = useState();
    const [S_No_Count, setCount] = useState(0);
    const [search_key, setsearch_key] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [submitLoader, setsubmitLoader] = useState(false);

    
    const [state, setstate] = useState(""); 
    
    const [State, setState] = useState("");
    const [country, setcountry] = useState("");
    const [selectedState, setselectedState] = useState("");
 
    
    const [StateList, setStateList] = useState();
    const [Countrylist, setCountrylist] = useState();
    
  
    useEffect(() => {
      getStateList();
      getCountryList();
    }, [search_key, currentPage]);
  
    const getStateList = () => {
      setLoading(true);
      const param = {
        limit: 10,
        page: currentPage,
        sorting: "sortingKey|desc",
        search_key: search_key,
      };
  
      PostService(API_URL.GET_STATES_LIST, param).then(
        (res) => {
          console.log(res);
          if (res.data.status === true) {
            setStateList(res.data.data.rows);
            SetTotalPageCount(res.data.totalPages);
            SetTotalCount(res.data.totalItems);
            setCount(res.data.currentPage * param.limit);
            setLoading(false);
          } else {
            showErrorAlert(res.data?.message);
            setLoading(false);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
          setLoading(false);
        }
      );
    };
  
    const getCountryList = () => {
      setLoading(true);
      PostService(API_URL.GET_COUNTRY_LIST).then(
        (res) => {
          if (res.data.status === true) {
            setCountrylist(res?.data?.data);
            setLoading(false);
          } else {
            showErrorAlert(res.data?.message);
            setLoading(false);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
          setLoading(false);
        }
      );
    };
  
    useEffect(() => {
      console.log(selectedState);
      setState(selectedState?.state_name);   
      setcountry(selectedState?.country?.country_id);
     
    }, [selectedState]);

    function resetModal() { 
        setState("");
        setcountry("");
        
        setError(false);
        setsubmitLoader(false);
      }
    
      const Add_State = (e) => {
        e.preventDefault();
    
        if (
          !country ||
          !State  
        ) {
          setError(true);
          return;
        }
    
        setsubmitLoader(true);
    
        const formData = new FormData();
        if (state !== "Add") {
          formData.append("id", selectedState?.state_id);
        }
        formData.append("country_id", country);
        formData.append("state_name", State); 
      
        const apiURL =
          state === "Add" ? API_URL.ADD_STATE_LIST : API_URL.UPDATE_STATE;
    
        PostService(apiURL, formData).then(
          (res) => {
            if (res.data.status === true) {
              showSuccessAlert(res?.data?.message, getStateList);
              resetModal();
              document.getElementById("closeEditModal").click(); 
            } else {
              showErrorAlert(res.data?.message);
            }
          },
          (err) => {
            showErrorAlert(err.data?.message);
          }
        );
      };

    function Delete(id, name) {
        const data = {
          id: id,
        };
    
        showDeleteConfirmation(name, () => {
          PostService(API_URL.DELETE_STATE, data).then(
            (res) => {
              if (res.data.status) {
                showSuccessAlert(res?.data?.message, getStateList);
              } else {
                showErrorAlert(res.data?.message);
              }
            },
            (err) => {
              showErrorAlert(err.data?.message);
            }
          );
        });
      }
    
      const handlePageClick = (e) => {
        setCurrentPage(e - 1);
      };

  return (
    <div>
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h3>States List</h3>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb float-sm-right">
              <Link
                to="/panel/dashboard"
                className="breadcrumb-item"
                style={{ textDecoration: "none" }}
              >
                Dashboard
              </Link>
              <Link className="breadcrumb-item active">States List </Link>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="align-items-center d-flex justify-content-between row">
                  <div className="col-md-4 p-0">
                    <div className="offset-md-1">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        data-toggle="modal"
                        data-target="#EditModal"
                        onClick={() => {
                          setstate("Add");
                          resetModal();
                        }}
                      >
                        Add State
                      </button>
                    </div>
                  </div>
                  <div className="col-md-4 p-0">
                    <nav className="navbar">
                      <input
                        type="text"
                        name="firstnamesearch"
                        placeholder="Search by Keyword"
                        className="form-control"
                        autoComplete="off"
                        onChange={(e) => {
                          setTimeout(() => {
                            setsearch_key(e.target.value);
                            setCurrentPage(0);
                          }, 400);
                        }}
                      />
                    </nav>
                  </div>
                </div>

                <div>
                  <div>
                    <div className="table-responsive mt-4">
                      {!loading && (
                        <table className="table table-hover table-bordered table-striped">
                          <thead>
                            <tr>
                              <th className="text-center">S.No</th>
                              <th className="text-center">State Name</th>
                              <th className="text-center">Country Name</th>
                              <th className="text-center">Country Code</th>
                              {/* <th className="text-center">Calling Code</th> */}
                              <th className="text-center">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {StateList &&
                              StateList?.map((item, i) => (
                                <tr key={i}>
                                  <td className="text-center">{i+ S_No_Count + 1}</td>
                                  <td className="text-center">
                                    {item?.state_name
                                      ? item?.state_name
                                      : "N/A"}
                                  </td>
                                  <td className="text-center">
                                    {item?.country?.country_name
                                      ? item?.country?.country_name
                                      : "N/A"}
                                  </td>
                                  <td className="text-center">
                                    {item?.country?.country_code
                                      ? item?.country?.country_code
                                      : "N/A"}
                                  </td>
                                  {/* <td className="text-center">
                                    {item?.country?.calling_codes
                                      ? item?.country?.calling_codes
                                      : "N/A"}
                                  </td> */}
 
                                  <td className="text-center">
                                  
                                    <span
                                      title="Edit"
                                      style={{ cursor: "pointer" }}
                                      className="mx-2"
                                      data-toggle="modal"
                                      data-target="#EditModal"
                                      onClick={() => {
                                        setstate("Edit");
                                        setselectedState(item);
                                      }}
                                    >
                                      <i className="text-dark fas fa-pen"></i>{" "}
                                    </span> 
                                    <span
                                      title="Delete"
                                      style={{ cursor: "pointer" }}
                                      className="mx-2"
                                      onClick={() => {
                                        Delete(item?.state_id, "State");
                                      }}
                                    >
                                      <i className="text-danger fas fa-trash"></i>{" "}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            {StateList && StateList.length === 0 && (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  <h6 className="p-3"> No Data Found </h6>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                      {loading ? (
                        <div className="LoaderSpinner">
                           <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                          <div>Loading... Please wait.</div>
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="mt-4">
                        <Pagination
                          counting={S_No_Count}
                          totaldata={TotalCount}
                          pagecount={TotalPageCount}
                          onChangePage={handlePageClick}
                          activePage={currentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* ---------------- add edit modal -----------*/}
    <div
      className="modal fade"
      id="EditModal"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title" id="exampleModalLabel">
              {state} State
            </h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close" 
            >
              {" "}
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form>
            <div className="modal-body">
              <div className="row"> 
                <div className="form-group col-md-12">
                  <label>Select Country</label>
                  <select
                    className="form-control"
                    value={country}
                    onChange={(e) => setcountry(e?.target.value)}
                  >
                    <option value="" default hidden>
                      Select
                    </option>
                    {Countrylist?.map((item, i) => (
                      <option value={item?.country_id} key={i}>
                        {item?.country_name}
                      </option>
                    ))}
                  </select>
                  {error && !country && (
                    <div className="error mt-1">country is required</div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="form-group col-md-12">
                  <label>State</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="State" 
                    value={State}
                    onChange={(e) => setState(e?.target.value)}
                  /> 
                  {error && !State && (
                    <div className="error mt-1">State is required</div>
                  )}
                </div> 
              </div>
                
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                id="closeEditModal"
                data-dismiss="modal" 
              >
                Close
              </button>

              <button
                className="btn btn-primary"
                onClick={(e) => Add_State(e)}
                disabled={submitLoader}
              >
                {submitLoader ? (
                  <i className="fas fa-spinner fa-spin"></i> 
                ) : state === "Add" ? (
                  "Add"
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  )
}
